import React, { FC, useRef, useState } from 'react'
import cn from 'classnames'
import styles from './CurrencyInput.module.css'
import { InputText } from '../InputText'
import { DropdownHeader } from '../../../DropdownHeader'
import { CurrencyIcon } from '../../../Icon'
import { useOnClickOutside } from '../../../../hooks/useClickOutside'

type Props = {
  title: string
  currency: string
  balanceText?: string
  balanceError?: boolean
  onClickBalance?: () => void
  dropdownEnabled?: boolean
  className?: string
}

export const CurrencyInput: FC<React.HTMLProps<HTMLInputElement> & Props> = ({
  title,
  currency,
  balanceText,
  balanceError,
  onClickBalance,
  dropdownEnabled = true,
  className,
  ...otherProps
}) => {
  const { disabled } = otherProps

  const [shouldShowDropdown, setShouldShowDropdown] = useState(false)
  const ref = useRef(null)

  const onOpenDropdown = () => {
    if (dropdownEnabled) return
    setShouldShowDropdown(true)
  }

  useOnClickOutside(ref, () => {
    if (dropdownEnabled) {
      setShouldShowDropdown(false)
    }
  })

  return (
    <label className={cn([styles.root, className])}>
      <div
        className={cn(styles.inputWrapper, {
          [styles.disabled]: disabled
        })}
      >
        <span className={styles.title}>{title}</span>
        <InputText
          className={styles.input}
          autoComplete='off'
          {...otherProps}
        />
        {Boolean(balanceText) && (
          <small
            onClick={onClickBalance}
            className={cn([
              styles.balanceText,
              onClickBalance && styles.clickable,
              balanceError && styles.error
            ])}
          >
            {balanceText}
          </small>
        )}
        <div
          className={cn(
            styles.currencyPicker,
            !dropdownEnabled && styles.dropdownDisabled
          )}
        >
          <DropdownHeader
            onClick={onOpenDropdown}
            shouldShowArrow={dropdownEnabled}
            isActive={shouldShowDropdown}
            className={cn(
              styles.currencyDropdown,
              shouldShowDropdown && styles.currencyDropdownOpen
            )}
          >
            <CurrencyIcon icon={currency} className={styles.currencyIcon} />
            <span>{currency}</span>
          </DropdownHeader>
        </div>
      </div>
    </label>
  )
}
